<div class="content-container">

  <app-sidenav class="sidenav" [chats]="chats" (onNewChat)="startNewChat()"></app-sidenav>

  <div class="chat-container">

    <div class="feed">

      @if (!chat && !loading) {
        <app-welcome-box></app-welcome-box>
      }

      @if (chat) {
        @for (chat_item of chat.chats; let i = $index; track trackByChatId) {
          <app-chat-box [chat]="chat_item"
            [content_array]="chat_item.content_array"
            [isStreaming]="chat_item.isStreaming ?? false"
            [isLast]="i === chat.chats.length - 1"
            (refreshRequested)="onRefresh($event)">
          </app-chat-box>
        }
      }

      @if (loading) {
        <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding: 1rem">
          <mat-spinner diameter="35"></mat-spinner>
        </div>
      }

    </div>

    @if (showUsers) {
      <ul class="select-list">
        @for (user of users; track trackByUserId) {
          <li (click)="selectUser(user)">
            {{ user.first_name + ' ' + user.last_name }}
          </li>
        }
      </ul>
    }

    <div class="chat-input" [formGroup]="questionForm">
      <input
        #questionInput
        formControlName="question"
        (keydown.enter)="sendQuestion()"
        (input)="updateFilteredUsers($event)"
      >

      <lib-icon-button (click)="sendQuestion()">
        <mat-icon>send</mat-icon>
      </lib-icon-button>
    </div>

  </div>

</div>
